import React from 'react';
import PropTypes from 'prop-types';

const Add = ({ className, color, onClick }) => (
  <svg className={className} onClick={onClick} viewBox="0 0 24 24">
    <path
      d="M11 11H7.995c-.54 0-.995.448-.995 1 0 .556.446 1 .995 1H11v3.005c0 .54.448.995 1 .995.556 0 1-.446 1-.995V13h3.005c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1H13V7.995c0-.54-.448-.995-1-.995-.556 0-1 .446-1 .995V11zm1 13c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

Add.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

Add.defaultProps = {
  color: '#3F9FFF',
};

export default Add;
